export default __webpack_public_path__ + "static/JackBurdick-e41e8cbf355e54791bb8af14e4c35d6e.jpg";